// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonDialog_ButtonBase__2IesV","ButtonPrimary":"ButtonDialog_ButtonPrimary__1IF07","ButtonSecondary":"ButtonDialog_ButtonSecondary__1GORW"};